import { render, staticRenderFns } from "./TicketPreviewHeader.vue?vue&type=template&id=96e6016e&scoped=true"
import script from "./TicketPreviewHeader.vue?vue&type=script&lang=js"
export * from "./TicketPreviewHeader.vue?vue&type=script&lang=js"
import style0 from "./TicketPreviewHeader.vue?vue&type=style&index=0&id=96e6016e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e6016e",
  null
  
)

export default component.exports